/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 23.11.12, 13:44
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { TextFormat } from "@goodgamestudios/createjs-utilities";

export class TextFormatUtil {
    public static cloneTextFormat(inputTextFormat: TextFormat): TextFormat {
        let outputTextFormat: TextFormat = new TextFormat();

        outputTextFormat.align = inputTextFormat.align;
        outputTextFormat.blockIndent = inputTextFormat.blockIndent;
        outputTextFormat.bold = inputTextFormat.bold;
        outputTextFormat.bullet = inputTextFormat.bullet;
        outputTextFormat.color = inputTextFormat.color;
        // outputTextFormat.display = inputTextFormat.display;
        outputTextFormat.font = inputTextFormat.font;
        outputTextFormat.indent = inputTextFormat.indent;
        outputTextFormat.indent = inputTextFormat.indent;
        outputTextFormat.italic = inputTextFormat.italic;
        outputTextFormat.kerning = inputTextFormat.kerning;
        outputTextFormat.leading = inputTextFormat.leading;
        outputTextFormat.leftMargin = inputTextFormat.leftMargin;
        outputTextFormat.letterSpacing = inputTextFormat.letterSpacing;
        outputTextFormat.rightMargin = inputTextFormat.rightMargin;
        outputTextFormat.size = inputTextFormat.size;
        outputTextFormat.tabStops = inputTextFormat.tabStops;
        outputTextFormat.target = inputTextFormat.target;
        outputTextFormat.underline = inputTextFormat.underline;
        outputTextFormat.url = inputTextFormat.url;

        return outputTextFormat;
    }
}
